import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  Currency,
  CurrencyResponse,
  InHold,
  Wallet,
} from '../../../../views/widgets/walletCard/types'
import { $params } from '../../../../features/router'

export const walletMounted = createEvent()

export const allCurrenciesMounted = createEvent()

export const setWallet = createEvent<Wallet>()

export const $wallet = restore(setWallet, {
  id: '',
  name: '',
  paymentProcessing: '',
  paymentSystem: {
    name: '',
  },
  paymentSystemId: '',
  mainDeposit: false,
  mainWithdrawal: false,
  startBalance: '',
  archivedAt: null,
  overallBalanceUsd: null,
  localBalances: [],
  lossPercentage: 0,
  reconciledAt: '',
  revisions: [],
})

export const getWallet = fx<void, Wallet>({
  method: 'GET',
  url: '/finance/wallet/',
})

export const getCurrencies = fx<void, CurrencyResponse>({
  method: 'GET',
  url: `/finance/currency`,
})

export const getInHold = fx<void, InHold>({
  method: 'GET',
  url: `/finance/transaction/hold`,
})

export const $currencies = restore<Currency[]>(
  getCurrencies.doneData.map((a) => a.body.items),
  [],
)

export const $inHold = restore<InHold>(
  getInHold.doneData.map((a) => a.body),
  { total: 0 },
)

sample({
  clock: walletMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.walletID
    }
    return {
      url: `/finance/wallet/${id}`,
    }
  },
  target: getWallet,
})

sample({
  clock: walletMounted,
  fn: () => {
    let query = {
      order: 'code',
    }
    return {
      query,
    }
  },
  target: getCurrencies,
})

sample({
  clock: allCurrenciesMounted,
  fn: () => {
    let query = {
      order: 'code',
    }
    return {
      query,
    }
  },
  target: getCurrencies,
})

sample({
  clock: getWallet.doneData,
  fn: (doneData) => doneData.body,
  target: setWallet,
})

sample({
  // @ts-ignore
  clock: walletMounted,
  source: $params,
  fn: (params) => {
    let query = {
      where: JSON.stringify({
        walletId: params?.walletID,
        type: 'Reserve',
        inProgress: true,
      }),
    }

    return {
      query,
    }
  },
  target: getInHold,
})
